
import generateHeader from '~/helpers/header'
export default {
  async asyncData({ error, app: { $storyblok } }) {
    try {
      const { story } = await $storyblok.getStory(
        '/static_pages/privacy-policy'
      )
      if (
        story.content.offline &&
        process.env.PRIMARY_HOST === 'https://www.lolelife.com'
      )
        error({
          statusCode: 404,
          message: '[PAGE] Page offline by SB',
        })
      return { story: story.content }
    } catch (e) {
      error({
        statusCode: 500,
        message: '[PAGE] Call storyblok privacy policy failed: ' + e,
      })
    }
  },
  head() {
    if (!this.story.seo) return
    this.story.seo.og_image = this.story.seo.og_image
      ? this.story.seo.og_image
      : this.$config.DEFAULT_OG_IMAGE

    return generateHeader({
      ...this.story.seo,
      path: this.$route.path,
      isNoIndex: this.story.noIndex,
    })
  },
  mounted() {
    if (window.location.search.includes('_storyblok')) {
      this.$storybridge(() => {
        const { StoryblokBridge } = window
        const storyblokInstance = new StoryblokBridge()

        // Use the input event for instant update of content
        storyblokInstance.on('input', (event) => {
          if (event.story.id === this.story.id) {
            this.story.content = event.story.content
          }
        })
        // Use the bridge to listen the events
        storyblokInstance.on(['published', 'change'], (event) => {
          // window.location.reload()
          this.$nuxt.$router.go({
            path: this.$nuxt.$router.currentRoute,
            force: true,
          })
        })
      })
    }
  },
}
